import { api } from "./clientInstance";

export const fetchFriends        = ()           => api("/friends");
export const fetchPendingFriends = ()           => api("/friends/pending");
export const sendFriendRequest   = (username)   => api(`/friends/request/${encodeURIComponent(username)}`, { method: "POST" });
export const acceptFriend        = (requesterId) => api(`/friends/accept/${requesterId}`, { method: "PUT" });
export const rejectFriend        = (requesterId) => api(`/friends/reject/${requesterId}`, { method: "PUT" });
export const cancelFriendRequest = (addresseeId) => api(`/friends/cancel/${addresseeId}`, { method: "DELETE" });
export const removeFriend        = (userId)      => api(`/friends/${userId}`, { method: "DELETE" });
